var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 183,
    viewBox: "0 0 156 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.692 182.89C137.017 159.947 109.074 145.374 77.846 145.374C46.618 145.374 18.674 159.947 0 182.89H18.442C34.143 168.313 54.92 159.443 77.705 159.443C100.49 159.443 121.267 168.313 136.969 182.89H155.692ZM81.944 133.627C52.34 133.627 27.058 108.483 43.472 67.216L55.196 77.922C48.189 101.22 60.223 117.161 81.068 117.686C102.264 118.212 115.752 95.965 119.956 74.944C125.211 48.844 123.81 21.342 97.71 16.612C82.995 13.985 66.704 19.065 62.5 33.954C55.668 57.953 81.419 67.061 106.994 65.31L107.344 81.075C70.383 83.878 36.925 64.785 47.085 29.75C53.216 8.37901 74.412 -3.35699 99.987 0.847006C136.247 6.97701 142.553 41.837 135.547 77.922C129.766 108.402 109.446 133.627 81.944 133.627Z",
    fill: "#042D21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 183,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonGreen);
export default __webpack_public_path__ + "static/media/person-green.1fa73101ebd4543e5963943df5b0f45c.svg";
export { ForwardRef as ReactComponent };